module.exports = __webpack_public_path__ + "img/vip_by_bg.5867c117.png";